import { render, staticRenderFns } from "./swatch-color-picker.vue?vue&type=template&id=0e1b5746&scoped=true&"
import script from "./swatch-color-picker.vue?vue&type=script&lang=js&"
export * from "./swatch-color-picker.vue?vue&type=script&lang=js&"
import style0 from "./swatch-color-picker.vue?vue&type=style&index=0&id=0e1b5746&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1b5746",
  null
  
)

export default component.exports